import { render, staticRenderFns } from "./DailyQuizDetails.vue?vue&type=template&id=08024862&"
import script from "./DailyQuizDetails.vue?vue&type=script&lang=js&"
export * from "./DailyQuizDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports